import { useContext, useRef } from "react";
import { useNavigate } from "react-router";
import { OverflowFrame, PageHeading } from "../../externalComponents";
import { useIsMobile } from "../../externalComponents/useIsMobile";
import { CustomerContext } from "../../providers";
import OngoingSendings from "./components/OngoingSendings";
import PastSendings from "./components/PastSendings";
import ScheduledSendings from "./components/ScheduledSendings";
import StoppedSendings from "./components/StoppedSendings";

export default function SendingsPage() {
  const { user } = useContext(CustomerContext);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const scheduledRef = useRef();
  const stoppedRef = useRef();
  const pastRef = useRef();

  return (
    <>
      <PageHeading
        title="Sendings"
        primaryAction="Back"
        handlePrimaryAction={() => navigate("/campaigns")}
      />
      <OverflowFrame>
        <div className="mx-3 md:mx-0">
          <StoppedSendings
            ref={stoppedRef}
            user={user}
            isMobile={isMobile}
            onScheduledRefresh={() => scheduledRef.current?.refresh()}
          />
          <ScheduledSendings
            ref={scheduledRef}
            user={user}
            isMobile={isMobile}
            onStoppedRefresh={() => stoppedRef.current?.refresh()}
          />
          <OngoingSendings user={user} isMobile={isMobile} />
          <PastSendings ref={pastRef} user={user} isMobile={isMobile} />
        </div>
      </OverflowFrame>
    </>
  );
}
